import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const pdfCo = defineConnector({
  identifier: "pdfCo",
  name: "PDFCo",
  tagLine: "PDF and document processing API",
  logo,
  protocol: "http",
  tags: ["documents"],
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your PDFCo API key",
      items: [
        {
          kind: "markdown",
          content:
            "In PDFCo, copy your API key from the dashboard. The API sends it in the `x-api-key` header.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.pdf.co/v1/account/credit/balance",
  },
  defaultUrlPattern: () => "https://api\\.pdf\\.co/.*",
});
